import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from 'src/app/shared/models/id-name.model';
import { DocResources } from 'src/app/shared/enums/docs-resources.enum';

@Pipe({
  name: 'getDocResources',
  standalone: false
})
export class DocResourcesPipe implements PipeTransform {
  public transform(value: DocResources): string {
    return getDocResources(value);
  }
}

export function getDocResources(value: DocResources): string {
  switch (value) {
    case DocResources.Pdf:
      return 'pdf';
    case DocResources.Doc:
      return 'doc';
    case DocResources.Docx:
      return 'docx';
    case DocResources.Jpg:
      return 'jpg';
    case DocResources.Jpeg:
      return 'jpeg';
    case DocResources.Png:
      return 'png';
    case DocResources.Bmp:
      return 'bmp';
    case DocResources.Gif:
      return 'gif';
    case DocResources.Xlsx:
      return 'xlsx';
    case DocResources.Wpd:
      return 'wpd';
    case DocResources.Xls:
      return 'xls';
    case DocResources.Txt:
      return 'txt';
    case DocResources.Ppt:
      return 'ppt';
    case DocResources.Pptx:
      return 'pptx';
    case DocResources.Mov:
      return 'mov';
    case DocResources.Mp4:
      return 'mp4';
    case DocResources.Mp3:
      return 'mp3';
    case DocResources.Wmv:
      return 'wmv';
    case DocResources.Avi:
      return 'avi';
    default:
      throw new Error(`Unsupported value for DocResources: ${value}.`);
  }
}

export function getDocResourcesList(): IdName[] {
  return enumToList(DocResources, getDocResources);
}
